import React from "react";

function Empowering() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                Crypto Gaming App Development by Xeer Technology
              </h2>
              <h3>Empowering the Next Generation of Gaming</h3>
              <p>
                Xeer Technology offers comprehensive Crypto Gaming App
                Development solutions, enabling developers and businesses to
                harness the potential of blockchain in gaming. We design and
                build cutting-edge gaming applications that integrate features
                like play-to-earn models, NFTs, and decentralized economies,
                creating engaging and profitable experiences for players
                worldwide.
              </p>
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Empowering;
